import { Autocomplete, TextField, Typography } from "@mui/material";
import {
  DateTimePicker,
  LocalizationProvider,
  renderTimeViewClock,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { HandleSkeletion } from "../../../../utils/constants";
import { CustomDiv } from "../../../chat-bot/style";
import { CommonGrid2 } from "../../../common-components/StyledComponents";
import dayjs from "dayjs";

function JobOwnerExecutive({
  userData,
  handleMenuItem,
  marginBottom = "1rem",
  loading,
  handleDataTime,
}) {
  return (
    <CommonGrid2
      display={"flex"}
      flexDirection={"column"}
      justifyContent={"center"}
      alignItems={"flex-start"}
      gap={"0.5rem"}
      width={"100%"}
      marginBottom={marginBottom}
    >
      <Typography variant="h5" fontWeight={500}>
        Job Details
      </Typography>
      <CustomDiv
        display={"flex"}
        flexDirection={"column"}
        justifyContent={"center"}
        alignItems={"center"}
        gap={"1rem"}
        width={"100%"}
        flexWrap="wrap"
      >
        {loading ? (
          <HandleSkeletion height={50} width={"100%"} transform={"scale(1)"} />
        ) : (
          <Autocomplete
            options={userData?.user_list || []}
            getOptionLabel={(opt) => opt.username || opt}
            onChange={(event, value) =>
              handleMenuItem(value, "account_executive")
            }
            ListboxProps={{
              id: "custom-autocomplete-list",
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Account Executive"
                label="Account Executive"
              />
            )}
            sx={{
              "& .MuiAutocomplete-inputRoot": {
                alignItems: "center",
                borderRadius: "6px",
                backgroundColor: "#FFFFFF",
              },
              "& input.MuiInputBase-input": {
                padding: "4px 5px !important",
              },
              "& .MuiInputBase-input::placeholder": {
                color: "#667085",
                opacity: 1,
                fontSize: "14px",
                fontWeight: 500,
              },
              "& label.MuiInputLabel-sizeMedium": {
                top: "-5px",
              },
              "& label.MuiInputLabel-shrink": {
                top: "0px",
              },
              "& fieldset": {
                border: "1px solid #D0D5DD",
              },
              width: "100%",
            }}
          />
        )}
        {loading ? (
          <HandleSkeletion height={50} width={"100%"} transform={"scale(1)"} />
        ) : (
          <Autocomplete
            options={userData?.user_list || []}
            getOptionLabel={(opt) => opt.username || opt}
            onChange={(event, value) => handleMenuItem(value, "job_owner")}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Job Owner"
                label="Job Owner"
              />
            )}
            ListboxProps={{
              id: "custom-autocomplete-list",
            }}
            sx={{
              "& .MuiAutocomplete-inputRoot": {
                alignItems: "center",
                borderRadius: "6px",
                backgroundColor: "#FFFFFF",
              },
              "& input.MuiInputBase-input": {
                padding: "4px 5px !important",
              },
              "& .MuiInputBase-input::placeholder": {
                color: "#667085",
                opacity: 1,
                fontSize: "14px",
                fontWeight: 500,
              },
              "& fieldset": {
                border: "1px solid #D0D5DD",
              },
              "& label.MuiInputLabel-sizeMedium": {
                top: "-5px",
              },
              "& label.MuiInputLabel-shrink": {
                top: "0px",
              },

              width: "100%",
            }}
          />
        )}
      </CustomDiv>
      {loading ? (
        <HandleSkeletion height={50} width={"100%"} transform={"scale(1)"} />
      ) : (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DateTimePicker
            disablePast
            minDateTime={dayjs()}
            defaultValue={userData?.date_time}
            label="Submission Deadline"
            format="MMM DD YYYY hh:mm A"
            onChange={handleDataTime}
            slotProps={{
              textField: {
                error: false,
                helperText: "",
                placeholder: "Date and Time",
                fullWidth: true,
                inputProps: {
                  readOnly: true,
                },
                sx: {
                  marginTop: "10px",
                  "& fieldset": {
                    border: "1px solid #D0D5DD",
                    borderRadius: "5px",
                  },
                  "& input": {
                    padding: "13px",
                  },
                  "& label.MuiInputLabel-sizeMedium": {
                    top: "-5px",
                  },
                  "& label.MuiInputLabel-shrink": {
                    top: "0px",
                  },
                },
              },
            }}
            viewRenderers={{
              hours: renderTimeViewClock,
              minutes: renderTimeViewClock,
              seconds: renderTimeViewClock,
            }}
          />
        </LocalizationProvider>
      )}
    </CommonGrid2>
  );
}

export default JobOwnerExecutive;
